/**
 * 功能: 显示热区后展现的内容 可以显示图说、表说、数说
 */
<template lang="pug">
  div
    div(style='width:100%;height:100%;' :class="[elementData.attachment._class === 0 ?'img':'']")
      img(:src="url" v-if="elementData.attachment._class === 0" style="width:80%;height:80%")
      div.tablelook(v-html="elementData.attachment.html" v-if="elementData.attachment._class === 1")
      drawSziePro(v-if="elementData.attachment._class === 2" :dialogData="elementData.attachment" :isshow="true")
    p(style="width:100%;text-align: right;font-style:italic;font-size:smaller;" v-if="elementData.attachment.source") 来源：{{ elementData.attachment.source }}
</template>

<script>
import drawSziePro from '@/views/size/components/drawsizePro'
import apiImg from '@/apis/commuCore'
export default {
  name: 'elementDialog',
  props: {
    elementData: { type: Object, default: () => {} }
  },
  components: {
    drawSziePro
  },
  data () {
    return {
      url: ''
    }
  },
  watch: {
    elementData: {
      // 加载网络地址链接成本地url
      handler: function (val) {
        if (val.attachment && val.attachment._class === 0) {
          apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + val.attachment.hiImageUrl).then(res => {
            // console.log('res: ', res)
            // this.elementData.attachment.loImageUrl = window.URL.createObjectURL(res)
            this.url = window.URL.createObjectURL(res)
          })
        }
      },
      immediate: true
    }
  }

}
</script>

<style scoped>
.img{
  display: flex;
  justify-content:center;
}
.tablelook table{
  position: absolute;
  transform: scale(0.3,0.5);
  top: -68px;
  width: 818px;
  left: -270px;
}
</style>
